import React, { useEffect, useRef } from 'react';
import Period from './Period';

/**
 * 판매기간 Interval Custom Hook
 */
function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}

/**
 * 판매기간 컴포넌트
 */
function SalesPeriodUnit({ day, hour, minutes, seconds, setNow }) {
  useInterval(() => {
    const tickNow = new Date().getTime();
    setNow(tickNow);
  }, 1000);

  return (
    <div className="deal_info_unit">
      <div className="info_unit_title">
        <h3 className="title">판매기간</h3>
      </div>
      <Period day={day} hour={hour} minutes={minutes} seconds={seconds} />
    </div>
  );
}

export default SalesPeriodUnit;
